module.exports = __webpack_public_path__ + "static/img/eight_icon.9af72af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/riff/eight_icon.png
// module id = FyT/
// module chunks = 12